var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "hits-courses",
      class: {
        mobile: _vm.mobile,
        desktop: !_vm.mobile
      },
      attrs: { courses: _vm.courses, queryID: _vm.courseQueryID }
    },
    [
      _vm.mobile
        ? _c("AllCourseSearchCardsMobile", {
            attrs: {
              courses: _vm.courses,
              queryID: _vm.courseQueryID,
              "in-header": _vm.inHeader
            }
          })
        : _c("AllCourseSearchCards", {
            attrs: {
              courses: _vm.courses,
              queryID: _vm.courseQueryID,
              mobile: _vm.mobile,
              "in-header": _vm.inHeader,
              "is-staff-user": _vm.isStaffUser
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }